$(document).ready(function (){
    $('body').on('click', '.faq_item__title', function (e){
        e.preventDefault();
        if($(this).parent().parent().hasClass('open')){
            $(this).attr('aria-expanded', 'false').parent().siblings('.faq_item__content').slideUp().parent().removeClass('open');
        } else {
            $(this).attr('aria-expanded', 'true').parent().siblings('.faq_item__content').slideDown().parent().addClass('open');
        }


    });
    let i = 1;
    $('.faq_item').each(function (){

        $(this).find('.faq_item__title').attr('aria-controls', 'sect'+i);
        $(this).find('.faq_item__title').attr('id', 'accordion'+i+'id');
        $(this).find('.faq_item__content').attr('id', 'sect'+i);
        $(this).find('.faq_item__content').attr('aria-labelledby', 'accordion'+i+'id');
        i++
    })
})